class ProductStickyBar {
  public element: HTMLElement | null;
  public shareButton: HTMLButtonElement | null | undefined;

  cache() {
    this.element = document.querySelector('.m-product-sticky-bar');
    this.shareButton = this.element?.querySelector('.js-product-sticky-bar-share');
  }

  bindings() {
    this.shareButton?.addEventListener('click', async (e) => {
      e.preventDefault();

      const shareData = {
        url: (e.currentTarget as HTMLElement | null)?.dataset.url,
      };

      try {
        await navigator.share(shareData)
      } catch(err) {
        console.error(err);
      }
    });
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default ProductStickyBar;
